export const CONDENSED = "condensed";
export const DEFAULT = "default";